/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileDetailsImages } from './StoreProfileDetailsImages';
import {
    StoreProfileDetailsImagesFromJSON,
    StoreProfileDetailsImagesFromJSONTyped,
    StoreProfileDetailsImagesToJSON,
    StoreProfileDetailsImagesToJSONTyped,
} from './StoreProfileDetailsImages';
import type { StoreProfileAddress } from './StoreProfileAddress';
import {
    StoreProfileAddressFromJSON,
    StoreProfileAddressFromJSONTyped,
    StoreProfileAddressToJSON,
    StoreProfileAddressToJSONTyped,
} from './StoreProfileAddress';
import type { StoreProfileDetailsOpeningHours } from './StoreProfileDetailsOpeningHours';
import {
    StoreProfileDetailsOpeningHoursFromJSON,
    StoreProfileDetailsOpeningHoursFromJSONTyped,
    StoreProfileDetailsOpeningHoursToJSON,
    StoreProfileDetailsOpeningHoursToJSONTyped,
} from './StoreProfileDetailsOpeningHours';
import type { StoreProfileContact } from './StoreProfileContact';
import {
    StoreProfileContactFromJSON,
    StoreProfileContactFromJSONTyped,
    StoreProfileContactToJSON,
    StoreProfileContactToJSONTyped,
} from './StoreProfileContact';

/**
 * 
 * @export
 * @interface StoreProfileStoreDetails
 */
export interface StoreProfileStoreDetails {
    /**
     * 
     * @type {StoreProfileStoreDetailsTypeEnum}
     * @memberof StoreProfileStoreDetails
     */
    type: StoreProfileStoreDetailsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileStoreDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileStoreDetails
     */
    openingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileStoreDetails
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfileStoreDetails
     */
    wpnStore: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfileStoreDetails
     */
    otsStore: boolean;
    /**
     * 
     * @type {StoreProfileAddress}
     * @memberof StoreProfileStoreDetails
     */
    address?: StoreProfileAddress;
    /**
     * 
     * @type {StoreProfileContact}
     * @memberof StoreProfileStoreDetails
     */
    contact?: StoreProfileContact;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfileStoreDetails
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfileStoreDetails
     */
    accessibilities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfileStoreDetails
     */
    equipments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfileStoreDetails
     */
    paymentMethods?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreProfileStoreDetails
     */
    activities?: Array<string>;
    /**
     * 
     * @type {StoreProfileDetailsOpeningHours}
     * @memberof StoreProfileStoreDetails
     */
    openingHours?: StoreProfileDetailsOpeningHours;
    /**
     * 
     * @type {StoreProfileDetailsImages}
     * @memberof StoreProfileStoreDetails
     */
    images?: StoreProfileDetailsImages;
}


/**
 * @export
 */
export const StoreProfileStoreDetailsTypeEnum = {
    Online: 'ONLINE',
    Local: 'LOCAL'
} as const;
export type StoreProfileStoreDetailsTypeEnum = typeof StoreProfileStoreDetailsTypeEnum[keyof typeof StoreProfileStoreDetailsTypeEnum];


/**
 * Check if a given object implements the StoreProfileStoreDetails interface.
 */
export function instanceOfStoreProfileStoreDetails(value: object): value is StoreProfileStoreDetails {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('wpnStore' in value) || value['wpnStore'] === undefined) return false;
    if (!('otsStore' in value) || value['otsStore'] === undefined) return false;
    return true;
}

export function StoreProfileStoreDetailsFromJSON(json: any): StoreProfileStoreDetails {
    return StoreProfileStoreDetailsFromJSONTyped(json, false);
}

export function StoreProfileStoreDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileStoreDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'openingDate': json['openingDate'] == null ? undefined : json['openingDate'],
        'description': json['description'] == null ? undefined : json['description'],
        'wpnStore': json['wpnStore'],
        'otsStore': json['otsStore'],
        'address': json['address'] == null ? undefined : StoreProfileAddressFromJSON(json['address']),
        'contact': json['contact'] == null ? undefined : StoreProfileContactFromJSON(json['contact']),
        'categories': json['categories'] == null ? undefined : json['categories'],
        'accessibilities': json['accessibilities'] == null ? undefined : json['accessibilities'],
        'equipments': json['equipments'] == null ? undefined : json['equipments'],
        'paymentMethods': json['paymentMethods'] == null ? undefined : json['paymentMethods'],
        'activities': json['activities'] == null ? undefined : json['activities'],
        'openingHours': json['openingHours'] == null ? undefined : StoreProfileDetailsOpeningHoursFromJSON(json['openingHours']),
        'images': json['images'] == null ? undefined : StoreProfileDetailsImagesFromJSON(json['images']),
    };
}

export function StoreProfileStoreDetailsToJSON(json: any): StoreProfileStoreDetails {
    return StoreProfileStoreDetailsToJSONTyped(json, false);
}

export function StoreProfileStoreDetailsToJSONTyped(value?: StoreProfileStoreDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'openingDate': value['openingDate'],
        'description': value['description'],
        'wpnStore': value['wpnStore'],
        'otsStore': value['otsStore'],
        'address': StoreProfileAddressToJSON(value['address']),
        'contact': StoreProfileContactToJSON(value['contact']),
        'categories': value['categories'],
        'accessibilities': value['accessibilities'],
        'equipments': value['equipments'],
        'paymentMethods': value['paymentMethods'],
        'activities': value['activities'],
        'openingHours': StoreProfileDetailsOpeningHoursToJSON(value['openingHours']),
        'images': StoreProfileDetailsImagesToJSON(value['images']),
    };
}

